module.exports = __webpack_public_path__ + "img/help6.55cafffd.png";